import { render } from "./portal-home.vue?vue&type=template&id=0e129244&scoped=true"
import script from "./portal-home.vue?vue&type=script&lang=js"
export * from "./portal-home.vue?vue&type=script&lang=js"

import "./portal-home.vue?vue&type=style&index=0&id=0e129244&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e129244"]])

export default __exports__